import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { VoiceCloneCanvas } from '@/features/app-shell/canvases/voice-clone-canvas'

export const Route = createFileRoute('/app/tools/voice-clone')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppToolsVoiceClonePage,
})

function AppToolsVoiceClonePage() {
  return (
    <AppShell activePath="/app">
      <VoiceCloneCanvas />
    </AppShell>
  )
}
